<template>
	<div>
		<app-layout>
			<template v-slot:header>
				<Header :title="$t('document_settings')"
				        :isFilter="false"/>
			</template>
			<template v-slot:header-mobile>
				<HeaderMobile :title="$t('document_settings')"
				              :isFilter="false"/>
			</template>
			<div class="row">
				<div class="col-12 col-md-12 col-xl-12 col-xxl-12 mt-4" v-if="form">
					<ValidationObserver ref="form">
						<div class="row">
                            <div class="col-12 border rounded p-4 mb-4">
                                <div class="row">
                                    <div class="col-6 col-md-6 col-xl-4">
                                        <ValidationProvider name="document_registrar" rules="required" v-slot="{valid, errors}">
                                            <b-form-group :label="$t('signer')">
                                                <staff-auto-complete
                                                    :valueObject="personObj"
                                                    :validate-error="errors[0]"
                                                    v-model="form.document_registrar">
                                                </staff-auto-complete>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>
                                    <div class="col-6 col-md-6 col-xl-4">
                                        <ValidationProvider name="document_registrar_title" rules="required" v-slot="{valid, errors}">
                                            <b-form-group :label="$t('signer_title')">
                                                <parameter-selectbox
                                                    code="document_signer_titles"
                                                    value-type="name"
                                                    text-type="name"
                                                    :validate-error="errors[0]"
                                                    v-model="form.document_registrar_title">
                                                </parameter-selectbox>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>

                                    <div class="col-6 col-md-6 col-xl-4">
                                        <ValidationProvider name="document_registrar_title_en" rules="required" v-slot="{valid, errors}">
                                            <b-form-group :label="$t('signer_title_en')">
                                                <parameter-selectbox
                                                    code="document_signer_titles"
                                                    value-type="name_en"
                                                    text-type="name_en"
                                                    :validate-error="errors[0]"
                                                    v-model="form.document_registrar_title_en">
                                                </parameter-selectbox>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 border rounded p-4 mb-4">
                                <div class="row">
                                    <div class="col-6 col-md-6 col-xl-4">
                                        <ValidationProvider name="document_registrar_behalf" rules="required" v-slot="{valid, errors}">
                                            <b-form-group :label="$t('document_registrar_behalf')">
                                                <staff-auto-complete
                                                    :valueObject="personObj"
                                                    :validate-error="errors[0]"
                                                    v-model="form.document_registrar_behalf">
                                                </staff-auto-complete>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>

                                    <div class="col-6 col-md-6 col-xl-4">
                                        <ValidationProvider name="document_registrar_title_behalf" rules="" v-slot="{valid, errors}">
                                            <b-form-group :label="$t('document_registrar_title_behalf')">
                                                <parameter-selectbox
                                                    code="document_signer_titles"
                                                    value-type="name"
                                                    text-type="name"
                                                    :validate-error="errors[0]"
                                                    v-model="form.document_registrar_title_behalf">
                                                </parameter-selectbox>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>

                                    <div class="col-6 col-md-6 col-xl-4">
                                        <ValidationProvider name="document_registrar_title_en_behalf" rules="" v-slot="{valid, errors}">
                                            <b-form-group :label="$t('document_registrar_title_en_behalf')">
                                                <parameter-selectbox
                                                    code="document_signer_titles"
                                                    value-type="name_en"
                                                    text-type="name_en"
                                                    :validate-error="errors[0]"
                                                    v-model="form.document_registrar_title_en_behalf">
                                                </parameter-selectbox>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>
                                    <div class="col-6 col-md-6 col-xl-4">
                                        <ValidationProvider name="document_registrar_behalf_start_date" rules="required" v-slot="{ valid, errors }">
                                            <b-form-group :label="$t('document_registrar_behalf_start_date')">
                                                <select-date
                                                    v-model="form.document_registrar_behalf_start_date"
                                                    :is-time="true"
                                                    :state="errors[0] ? false : null" />
                                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>

                                    <div class="col-6 col-md-6 col-xl-4">
                                        <ValidationProvider name="document_registrar_behalf_end_date" rules="required" v-slot="{ valid, errors }">
                                            <b-form-group :label="$t('document_registrar_behalf_end_date')">
                                                <select-date
                                                    v-model="form.document_registrar_behalf_end_date"
                                                    :is-time="true"
                                                    :state="errors[0] ? false : null" />
                                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 border rounded p-4 mb-4">
                                <div class="row">
                                    <div class="col-6 col-md-6 col-xl-4">
                                        <ValidationProvider name="rector" rules="required" v-slot="{valid, errors}">
                                            <b-form-group :label="$t('rector')">
                                                <staff-auto-complete
                                                    :valueObject="rectorObj"
                                                    :validate-error="errors[0]"
                                                    v-model="form.rector">
                                                </staff-auto-complete>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>

                                    <div class="col-6 col-md-6 col-xl-4">
                                        <ValidationProvider name="rector_title" rules="required" v-slot="{valid, errors}">
                                            <b-form-group :label="$t('rector_title')">
                                                <parameter-selectbox
                                                    code="rector_titles"
                                                    value-type="name"
                                                    text-type="name"
                                                    :validate-error="errors[0]"
                                                    v-model="form.rector_title">
                                                </parameter-selectbox>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>

                                    <div class="col-6 col-md-6 col-xl-4">
                                        <ValidationProvider name="rector_title_en" rules="required" v-slot="{valid, errors}">
                                            <b-form-group :label="$t('rector_title_en')">
                                                <parameter-selectbox
                                                    code="rector_titles"
                                                    value-type="name_en"
                                                    text-type="name_en"
                                                    :validate-error="errors[0]"
                                                    v-model="form.rector_title_en">
                                                </parameter-selectbox>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 border rounded p-4 mb-4">
                                <div class="row">
                                    <div class="col-6 col-md-6 col-xl-4">
                                        <ValidationProvider name="rector_behalf" rules="required" v-slot="{valid, errors}">
                                            <b-form-group :label="$t('rector_behalf')">
                                                <staff-auto-complete
                                                    :valueObject="personObj"
                                                    :validate-error="errors[0]"
                                                    v-model="form.rector_behalf">
                                                </staff-auto-complete>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>

                                    <div class="col-6 col-md-6 col-xl-4">
                                        <ValidationProvider name="rector_title_behalf" rules="" v-slot="{valid, errors}">
                                            <b-form-group :label="$t('rector_title_behalf')">
                                                <parameter-selectbox
                                                    code="rector_titles"
                                                    value-type="name"
                                                    text-type="name"
                                                    :validate-error="errors[0]"
                                                    v-model="form.rector_title_behalf">
                                                </parameter-selectbox>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>

                                    <div class="col-6 col-md-6 col-xl-4">
                                        <ValidationProvider name="rector_title_en_behalf" rules="" v-slot="{valid, errors}">
                                            <b-form-group :label="$t('rector_title_en_behalf')">
                                                <parameter-selectbox
                                                    code="rector_titles"
                                                    value-type="name_en"
                                                    text-type="name_en"
                                                    :validate-error="errors[0]"
                                                    v-model="form.rector_title_en_behalf">
                                                </parameter-selectbox>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>
                                    <div class="col-6 col-md-6 col-xl-4">
                                        <ValidationProvider name="rector_behalf_start_date" rules="required" v-slot="{ valid, errors }">
                                            <b-form-group :label="$t('rector_behalf_start_date')">
                                                <select-date
                                                    v-model="form.rector_behalf_start_date"
                                                    :is-time="true"
                                                    :state="errors[0] ? false : null" />
                                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>

                                    <div class="col-6 col-md-6 col-xl-4">
                                        <ValidationProvider name="rector_behalf_end_date" rules="required" v-slot="{ valid, errors }">
                                            <b-form-group :label="$t('rector_behalf_end_date')">
                                                <select-date
                                                    v-model="form.rector_behalf_end_date"
                                                    :is-time="true"
                                                    :state="errors[0] ? false : null" />
                                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-md-12 col-xl-12 col-xxl-12">
								<div class="row">
									<div class="col-sm-6 col-xs-12 mb-5">
										<b-button @click="save"
										          type="button"
										          variant="primary"
										          class="btn-lg d-flex justify-content-between align-items-center">
											{{ $t('save').toUpper() }}
										</b-button>
									</div>
								</div>
							</div>

						</div>
					</ValidationObserver>
				</div>
			</div>
		</app-layout>
	</div>
</template>
<script>
	// Template
	import AppLayout from "@/layouts/AppLayout";
	import Header from "@/layouts/AppLayout/Header";
	import HeaderMobile from "@/layouts/AppLayout/HeaderMobile";

	// Components
	import AcademicYearsSelectbox from "@/components/interactive-fields/AcademicYearsSelectbox";
	import SemestersSelectbox from "@/components/interactive-fields/SemestersSelectbox";
	import {ValidationObserver, ValidationProvider} from "vee-validate";
    import StaffAutoComplete from "@/components/interactive-fields/StaffAutoComplete"

	// Services
	import ConstantService from "@/services/ConstantService";
    import ParameterSelectbox from "@/components/interactive-fields/ParameterSelectbox";
    import qs from "qs";
    import PersonService from "@/services/PersonService";

	export default {
		components: {
            ParameterSelectbox,
			AppLayout,
			Header,
			HeaderMobile,
			AcademicYearsSelectbox,
			SemestersSelectbox,
            StaffAutoComplete,
			ValidationProvider,
			ValidationObserver,
		},
		data() {
			return {
				form: {
                    document_registrar: null,
                    document_registrar_title: null,
                    document_registrar_title_en: null,
                    rector: null,
                    rector_title: null,
                    rector_title_en: null,
                    document_registrar_behalf: null,
                    document_registrar_title_behalf: null,
                    document_registrar_title_en_behalf: null,
                    document_registrar_behalf_start_date: null,
                    document_registrar_behalf_end_date: null,
                    rector_behalf: null,
                    rector_title_behalf: null,
                    rector_title_en_behalf: null,
                    rector_behalf_start_date: null,
                    rector_behalf_end_date: null,
                },
                personObj: {},
                rectorObj: {},
			}
		},
		metaInfo() {
			return {
				title: this.$t("document_settings")
			}
		},
		methods: {
			async save() {
                if(this.checkPermission('constant_update')){
                    const isValid = await this.$refs.form.validate();
                    if (isValid) {
                        ConstantService.updateByKey('document_registrar', {value: this.form.document_registrar, type: 'person'}).catch(e=>{
                            this.showErrors(e);
                        }).then(response=>{
                            this.$toast.success(this.$t('updated'));
                        });
                        ConstantService.updateByKey('document_registrar_behalf', {value: this.form.document_registrar_behalf, type: 'person'}).catch(e=>{
                            this.showErrors(e);
                        }).then(response=>{
                            this.$toast.success(this.$t('updated'));
                        });
                        ConstantService.updateByKey('rector_behalf', {value: this.form.rector_behalf, type: 'person'}).catch(e=>{
                            this.showErrors(e);
                        }).then(response=>{
                            this.$toast.success(this.$t('updated'));
                        });
                        ConstantService.updateByKey('document_registrar_title', {value: this.form.document_registrar_title, type: 'string'}).catch(e=>{
                            this.showErrors(e);
                        });
                        ConstantService.updateByKey('document_registrar_title_en', {value: this.form.document_registrar_title_en, type: 'string'}).catch(e=>{
                            this.showErrors(e);
                        });
                        ConstantService.updateByKey('document_registrar_title_behalf', {value: this.form.document_registrar_title_behalf, type: 'string'}).catch(e=>{
                            this.showErrors(e);
                        });
                        ConstantService.updateByKey('document_registrar_title_en_behalf', {value: this.form.document_registrar_title_en_behalf, type: 'string'}).catch(e=>{
                            this.showErrors(e);
                        });
                        ConstantService.updateByKey('document_registrar_behalf_start_date', {value: this.form.document_registrar_behalf_start_date, type: 'date'}).catch(e=>{
                            this.showErrors(e);
                        });
                        ConstantService.updateByKey('document_registrar_behalf_end_date', {value: this.form.document_registrar_behalf_end_date, type: 'date'}).catch(e=>{
                            this.showErrors(e);
                        });

                        ConstantService.updateByKey('rector_title_behalf', {value: this.form.rector_title_behalf, type: 'string'}).catch(e=>{
                            this.showErrors(e);
                        });
                        ConstantService.updateByKey('rector_title_en_behalf', {value: this.form.rector_title_en_behalf, type: 'string'}).catch(e=>{
                            this.showErrors(e);
                        });
                        ConstantService.updateByKey('rector_behalf_start_date', {value: this.form.rector_behalf_start_date, type: 'date'}).catch(e=>{
                            this.showErrors(e);
                        });
                        ConstantService.updateByKey('rector_behalf_end_date', {value: this.form.rector_behalf_end_date, type: 'date'}).catch(e=>{
                            this.showErrors(e);
                        });
                        ConstantService.updateByKey('rector', {value: this.form.rector, type: 'person'}).catch(e=>{
                            this.showErrors(e);
                        }).then(response=>{
                            this.$toast.success(this.$t('updated'));
                        });
                        ConstantService.updateByKey('rector_title', {value: this.form.rector_title, type: 'string'}).catch(e=>{
                            this.showErrors(e);
                        });
                        ConstantService.updateByKey('rector_title_en', {value: this.form.rector_title_en, type: 'string'}).catch(e=>{
                            this.showErrors(e);
                        });
                    }
                } else {
                    this.$toast.error(this.$t('you_are_not_authorized_for_this_operation'))
                }
			},
			getSettings() {
                const config = {
                    params: {
                        filter: {
                            key: 'document_registrar,document_registrar_title,document_registrar_title_en,rector,rector_title,rector_title_en,document_registrar_behalf,' +
                                'document_registrar_title_behalf,document_registrar_title_en_behalf,document_registrar_behalf_start_date,document_registrar_behalf_end_date,rector_behalf,' +
                                'rector_title_behalf,rector_title_en_behalf,rector_behalf_start_date,rector_behalf_end_date',
                        },
                        limit: -1,
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false}),
                };
				ConstantService.getAll(config).then(response=>{
				    let data = this.groupBy(response.data.data, 'key');
				    if(data['document_registrar']){
				        this.form.document_registrar = data['document_registrar'][0].value;
                        PersonService.get(this.form.document_registrar).then(response => {
                            this.personObj = {
                                text: response.data.data.name+' '+response.data.data.surname,
                                value: this.form.document_registrar
                            }
                        })
                    }
                    if(data['document_registrar_behalf']){
				        this.form.document_registrar_behalf = data['document_registrar_behalf'][0].value;
                        PersonService.get(this.form.document_registrar_behalf).then(response => {
                            this.personObj = {
                                text: response.data.data.name+' '+response.data.data.surname,
                                value: this.form.document_registrar_behalf
                            }
                        })
                    }
                    if(data['rector_behalf']){
				        this.form.rector_behalf = data['rector_behalf'][0].value;
                        PersonService.get(this.form.rector_behalf).then(response => {
                            this.personObj = {
                                text: response.data.data.name+' '+response.data.data.surname,
                                value: this.form.rector_behalf
                            }
                        })
                    }
				    if(data['document_registrar_title']){
                        this.form.document_registrar_title = data['document_registrar_title'][0].value;
                    }
                    if(data['document_registrar_title_en']){
                        this.form.document_registrar_title_en = data['document_registrar_title_en'][0].value;
                    }
                    if(data['document_registrar_title_behalf']){
                        this.form.document_registrar_title_behalf = data['document_registrar_title_behalf'][0].value;
                    }
                    if(data['document_registrar_title_en_behalf']){
                        this.form.document_registrar_title_en_behalf = data['document_registrar_title_en_behalf'][0].value;
                    }
                    if(data['document_registrar_behalf_start_date']){
                        this.form.document_registrar_behalf_start_date = data['document_registrar_behalf_start_date'][0].value;
                    }
                    if(data['document_registrar_behalf_end_date']){
                        this.form.document_registrar_behalf_end_date = data['document_registrar_behalf_end_date'][0].value;
                    }
                    if(data['rector_title_behalf']){
                        this.form.rector_title_behalf = data['rector_title_behalf'][0].value;
                    }
                    if(data['rector_title_en_behalf']){
                        this.form.rector_title_en_behalf = data['rector_title_en_behalf'][0].value;
                    }
                    if(data['rector_behalf_start_date']){
                        this.form.rector_behalf_start_date = data['rector_behalf_start_date'][0].value;
                    }
                    if(data['rector_behalf_end_date']){
                        this.form.rector_behalf_end_date = data['rector_behalf_end_date'][0].value;
                    }
                    if(data['rector']){
                        this.form.rector = data['rector'][0].value;
                        PersonService.get(this.form.rector).then(response => {
                            this.rectorObj = {
                                text: response.data.data.name+' '+response.data.data.surname,
                                value: this.form.rector
                            }
                        })
                    }
                    if(data['rector_title']){
                        this.form.rector_title = data['rector_title'][0].value;
                    }
                    if(data['rector_title_en']){
                        this.form.rector_title_en = data['rector_title_en'][0].value;
                    }
                });
			}
		},
		created() {
			this.getSettings()
		}
	}
</script>
